import { Injectable } from '@angular/core';
import { WebkitService } from './webkit.service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentsService } from './enviroment.service';

@Injectable({
  providedIn: 'root',
})
export class SwapWifiService {
  baseUrl: string;
  constructor(
    readonly webkitService: WebkitService,
    readonly http: HttpClient,
    readonly env: EnvironmentsService
  ) {
    this.baseUrl = env.apiUrl;
  }
  convertMatAngularValueToDate(value: any): any {
    const dateOptions: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    };
    return new Date(value).toLocaleString('vi-VN', dateOptions);
  }
  convertNumber(n: any): string {
    return n > 9 ? '' + n.toString() : '0' + n.toString();
  }
  convertDateToDDMMYYYY(date: any): any {
    return [
      this.convertNumber(date.getDate()),
      this.convertNumber(date.getMonth() + 1),
      this.convertNumber(date.getFullYear()),
    ].join('/');
  }
  convertPrice(value: any): any {
    // if (!p) {
    //   return '';
    // } else {
    //   return p.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    // }
    if (value) {
      const num = typeof value === 'number' ? value : parseFloat(value);
      if (isNaN(num)) return value.toString();
      return new Intl.NumberFormat('de-DE').format(num);
    }
    return 0;

  }
  getListContract(version: string, data: any) {
    const headers = this.webkitService.returnHeader();
    return this.http.post(
      this.env.apiUrl +
        `/hi-ecom-shopping-v2-api/public/swap-wifi${version}/get-list-contract`,
      data,
      { headers }
    );
  }
  getInfo(version: string, data: any) {
    const headers = this.webkitService.returnHeader();
    return this.http.post(
      this.env.apiUrl + `/hi-ecom-shopping-v2-api/public/swap-wifi${version}/get-info`,
      data,
      { headers }
    );
  }
  getAppointmentTime(version: string, data: any) {
    const headers = this.webkitService.returnHeader();
    return this.http.post(
      this.env.apiUrl +
        `/hi-ecom-shopping-v2-api/public/swap-wifi${version}/get-appointment-time`,
      data,
      { headers }
    );
  }
  payment(version: string, data: any) {
    const headers = this.webkitService.returnHeader();
    return this.http.post(
      this.env.apiUrl + `/hi-ecom-shopping-v2-api/public/swap-wifi${version}/payment`,
      data,
      { headers }
    );
  }
}
